<template>
    <div>
        
        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtros" :sync="true" @sync="load()" />
                    </div>

                    <div class="col col-12 col-md-6">
                        <az-input
                            placeholder="Selecione o Filtro..."
                            icon="fas fa-filter fa-fw"
                            type="autocomplete"
                            optionsMode="aql"
                            service="pesquisa_alertas.index"
                            optionsDisplay="search"
                            v-model="filtros.filtro">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <!-- @click="$emit('criarfiltro')" -->
                                    <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="incluir_filtro()" v-if="!filtros.filtro" title="Incluir">
                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                    </button>
                                    <template v-else>
                                        <button class="btn btn-outline-danger" type="button" id="button-addon2" @click="filtros.filtro = ''" title="Limpar">
                                            <i class="fa fa-eraser" aria-hidden="true"></i>
                                        </button>
                                        <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="editar_filtro()" title="Editar">
                                            <i class="fas fa-edit"></i>
                                        </button>
                                    </template>
                                    <print-export v-if="false" printid="impressao" :dados="dados_exportacao" :left="true" />
                                </div>
                            </template>
                        </az-input>
                    </div>
                </div>

                <div class="form-row mt-2">
                    <div class="col col-12 col-md-3">
                        <az-input   
                            type="checkbox-group"
                            label="Último Atendimento do Paciente"
                            v-model="filtros.ultimo_atend">
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input   
                            type="checkbox-group"
                            label="Exportar Paciente Consolidado"
                            v-model="consolidar_paciente">
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-6">
                        <az-input   
                            type="checkbox-group"
                            :edicao="lista.length ? true : false"
                            label="Acrescentar resultados numa nova busca"
                            v-model="acrescentar_resultado">
                        </az-input>
                    </div>
                </div>

                <div class="form-row mt-2">
                    <div class="col col-12 col-md-6" v-if="dados && dados.programas && dados.programas.length">
                        <az-input
                            icon="fa-brands fa-gratipay fa-fw"
                            placeholder="Inclusão em Programa de Cuidado Coordenado..."
                            type="select"
                            optionsMode="json"
                            :optionsList="dados.programas"
                            optionsDisplay="search"
                            optionsData="id_cuidado_programa"
                            v-model="filtros.id_cuidado_programa">
                        </az-input>
                    </div>
                    <div class="col col-12" :class="( dados && dados.programas && dados.programas.length ) ? 'col-md-6' : ''">
                        <az-input
                            icon="fa fa-search fa-fw"
                            placeholder="Pesquisar..."
                            v-model="filtros.search">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <print-export v-show="lista.length" printid="impressao" :dados="dados_exportacao" :left="true" />
                                </div>
                            </template>
                        </az-input>
                    </div>
                </div>
            </div>
        </div>

        <div class="progress mt-1 mb-2">
            <div class="indeterminate" v-if="$store.state.loading && dados"></div>
            <div class="determinate" v-else></div>
        </div>

        <div class="alert alert-warning" v-if="consolidar_paciente">
            Ao selecionar a opção de "Exportar Paciente Consolidado", o arquivo exportado irá conter uma linha para cada paciente, colocando os diversos atendimentos como colunas. 
        </div>

        <div class="alert alert-warning" v-if="filtros.ultimo_atend">
            Ao selecionar a opção de "Último Atendimento do Paciente", o sistema irá listar apenas o último atendimento de cada paciente.
        </div>

        <az-empty-state 
            v-if="!dados || !lista.length" 
            :method="load"
            :icon="!filtros.id_pesquisa_alerta ? 'fas fa-filter' : 'fas fa-search'" 
            :msg="!filtros.id_pesquisa_alerta 
                ? 'Selecione o Filtro...' 
                : ( dados === null ? 'Realizar Pesquisa' : 'Nenhum paciente encontrado.' )"
            :action="( filtros.id_pesquisa_alerta && !dados ) ? 'Buscar' : ''" />

        <template v-else>

            <div class="alert alert-info d-flex justify-content-between">
                <div>
                    {{ dados.pa.search }}
                </div>
                <div>Período: {{ $util.getFormatDate(dados.periodo.inicio) }} a {{ $util.getFormatDate(dados.periodo.fim) }} </div>
            </div>

            <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item" role="presentation">
                    <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">
                        Relação
                        <span class="badge badge-secondary" v-if="lista">
                            {{ lista.length }}
                        </span>
                    </a>
                </li>
                <li class="nav-item" role="presentation">
                    <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">
                        Consolidações
                        <span class="badge badge-secondary" v-if="consolidacoes">
                            {{ consolidacoes }}
                        </span>
                    </a>
                </li>
            </ul>

            <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">

                    <div id="impressao">

                        <cabecalho-generico :titulo="dados.pa.search">
                            <div>Período: {{ $util.getFormatDate(dados.periodo.inicio) }} a {{ $util.getFormatDate(dados.periodo.fim) }} </div>
                            <div>
                                <div class="text-muted">
                                    {{ lista.length }}
                                    {{ lista.length > 1 ? 'pacientes encontrados' : 'paciente encontrado' }}
                                </div>
                            </div>
                        </cabecalho-generico>

                        <template v-if="info.analitico">
                            <table class="table table-hover bg-white cabecalho-fixo">
                                <thead>
                                    <tr>
                                        <th>Atendimento</th>
                                        <th>Paciente</th>
                                        <th>Procedimento</th>
                                        <th v-for="(campo, icx) in dados.pa.campos" :key="icx">
                                            {{ titulo_campo(campo) }}
                                        </th>
                                        <th class="text-right" v-if="filtros.id_cuidado_programa">
                                            <button type="button" class="btn btn-outline-primary btn-sm" @click="marcar_todos()">
                                                Todos
                                            </button>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, iix) in lista" :key="iix">
                                        <td>
                                            <div>
                                                #{{ item.id_atendimento }}
                                                <span class="badge badge-secondary" v-if="item.avulso">Avulso</span>
                                                <template v-if="item.paciente.cuidados && item.paciente.cuidados.length">
                                                    <span class="badge ml-1" 
                                                        :class="'badge-' + (cuidado.programa.st_cor ? cuidado.programa.st_cor : 'secondary')"
                                                        v-for="(cuidado, icx) in item.paciente.cuidados" :key="icx" 
                                                        :title="cuidado.programa.search">
                                                        {{ cuidado.programa.st_sigla }}
                                                    </span>
                                                </template>
                                            </div>
                                            
                                            <div class="small">
                                                {{ $util.getFormatDate(item.atendimento.dt_inicio) }}
                                            </div>
                                        </td>
                                        <td>
                                            {{ item.nome_paciente }}, 
                                            <span class="badge badge-light">
                                                {{ item.paciente.cadastro.ch_sexo }}, 
                                                {{ item.paciente.cadastro.idade_anos }}a
                                            </span>
                                            <div class="small text-muted">
                                                {{ item.plano.search }}
                                            </div>
                                        </td>
                                        <td>
                                            {{ item.procedimento.search }}
                                            <div>
                                                <span class="small text-muted">
                                                    {{ item.medico.search }}
                                                </span>
                                                <span class="badge badge-light ml-2" v-if="item.unidade_operacao && item.unidade_operacao.st_sigla" ttile="Unidade">
                                                    {{ item.unidade_operacao.st_sigla }}
                                                </span>

                                                <span class="badge badge-light ml-2" v-if="item.recepcao && item.recepcao.st_sigla" ttile="Recepção">
                                                    {{ item.recepcao.st_sigla }}
                                                </span>
                                            </div>
                                        </td>
                                        <td v-for="(campo, icx) in dados.pa.campos" :key="icx">
                                            {{ obter_valor(item, campo) }}
                                        </td>
                                        <td class="text-right" v-if="filtros.id_cuidado_programa">
                                            <input type="checkbox" v-model="item.selecionado">
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <!-- Selecionados -->
                            <nav class="navbar fixed-bottom navbar-light bg-light" v-if="filtros.id_cuidado_programa && total_selecionados > 0">
                                <div>
                                    {{ total_selecionados }} {{ total_selecionados > 1 ? 'selecionados' : 'selecionado' }}
                                </div>
                                <div>
                                    <az-submit color="success btn-sm" @click="incluir_no_programa()">Incluir no Programa</az-submit>
                                </div>
                            </nav>

                        </template>

                    </div>

                </div>

                <!-- Consolidações -->
                <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">

                    <div id="impressao" v-if="consolidacoes">
                        
                        <cabecalho-generico :titulo="dados.pa.search">
                            <div>Período: {{ $util.getFormatDate(dados.periodo.inicio) }} a {{ $util.getFormatDate(dados.periodo.fim) }} </div>
                            <div>
                                <div class="text-muted">
                                    {{ lista.length }}
                                    {{ lista.length > 1 ? 'pacientes encontrados' : 'paciente encontrado' }}
                                </div>
                            </div>
                        </cabecalho-generico>

                        <template v-if="dados.acoes && dados.acoes.tabelas && chaves(dados.acoes.tabelas)">

                            <div class="row">
                                <div v-for="(tabela, chave, itx) in dados.acoes.tabelas" :key="itx" class="col col-12 col-md-6">
                                    <table class="table table-sm bg-white table-hover">
                                        <thead>
                                            <tr>
                                                <th>{{ chave }}</th>
                                                <th class="text-right">Total</th>
                                                <th class="text-right">%</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(valor, titulo, iix) in tabela" :key="iix">
                                                <td>{{ titulo }}</td>
                                                <td class="text-right">{{ valor }}</td>
                                                <td class="text-right">{{ percentual(valor, tabela) }}</td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <th>Total</th>
                                                <th class="text-right">{{ totalizar(tabela) }}</th>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>

                        </template>

                        <template v-if="dados.graficos && dados.graficos.length">

                            <div class="row">
                                <div v-for="(grafico, igx) in dados.graficos" :key="'G'  + igx" class="col col-12 col-md-6">

                                    <template v-if="grafico.estilo && grafico.estilo != 'lista'">
                                        <div class="card" :class="grafico.full ? 'panel-fullscreen' : ''">
                                            <div class="card-header d-flex justify-content-between">
                                                <div>
                                                    {{ grafico.titulo }}
                                                </div>
                                                <a href="#" @click.prevent="grafico.full = !grafico.full">
                                                    <i class="fa-solid fa-expand" v-if="!grafico.full"></i>
                                                    <i class="fa-solid fa-compress" v-else></i>
                                                </a>
                                            </div>
                                            <div class="card-body">
                                                <Chart 
                                                    :type="grafico.estilo" 
                                                    :data="grafico.basicData" 
                                                    :options="grafico.options" />
                                            </div>
                                        </div>
                                    </template>

                                    <table class="table table-sm bg-white table-hover" v-else>
                                        <thead>
                                            <tr>
                                                <th>{{ grafico.titulo }}</th>
                                                <th class="text-right">Total</th>
                                                <th class="text-right" v-if="!grafico.quebra1">%</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-if="grafico.quebra1">
                                                <template v-for="(quebra1, titulo1, iq1) in agrupar(grafico.valores, 'quebra1')">
                                                    <tr :key="'q1.' + iq1" class="table-primary">
                                                        <th>
                                                            {{ titulo1 }}
                                                        </th>
                                                        <th class="text-right">{{ totalizar(quebra1, 'qtd') }}</th>
                                                    </tr>
                                                    <template v-if="grafico.quebra2">
                                                        <template v-for="(quebra2, titulo2, iq2) in agrupar(quebra1, 'quebra2')">
                                                            <tr :key="'q2.' + iq1 + '.' + iq2" class="table-info">
                                                                <th>
                                                                    {{ titulo2 }}
                                                                </th>
                                                                <th class="text-right">{{ totalizar(quebra2, 'qtd') }}</th>
                                                            </tr>
                                                            <template v-if="!grafico.sintetico">
                                                                <tr v-for="(valor, iix) in quebra2" :key="'q2.' + iq1 + '.' + iq2 + '.' + iix">
                                                                    <td>{{ valor.campo ? valor.campo.titulo : valor.id }}</td>
                                                                    <td class="text-right">{{ valor.qtd }}</td>
                                                                </tr>
                                                            </template>
                                                        </template>
                                                    </template>
                                                    <template v-else-if="!grafico.sintetico">
                                                        <tr v-for="(valor, iix) in quebra1" :key="'q2.' + iq1 + '.' + iq2 + '.' + iix">
                                                            <td>{{ valor.campo ? valor.campo.titulo : valor.id }}</td>
                                                            <td class="text-right">{{ valor.qtd }}</td>
                                                        </tr>
                                                    </template>
                                                </template>
                                                <!--
                                                <tr v-for="(valor, titulo, iix) in grafico.valores" :key="iix">
                                                    <td>{{ valor.campo ? valor.campo.titulo : valor.id }}</td>
                                                    <td class="text-right">{{ valor.qtd }}</td>
                                                    <td class="text-right">{{ percentual(valor.qtd, grafico.valores, 'qtd') }}</td>
                                                </tr>
                                                -->
                                            </template>
                                            <template v-else>
                                                <tr v-for="(valor, titulo, iix) in grafico.valores" :key="iix">
                                                    <td>{{ valor.campo ? valor.campo.titulo : valor.id }}</td>
                                                    <td class="text-right">{{ valor.qtd }}</td>
                                                    <td class="text-right">{{ percentual(valor.qtd, grafico.valores, 'qtd') }}</td>
                                                </tr>
                                            </template>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <th>Total</th>
                                                <th class="text-right">{{ totalizar(grafico.valores, 'qtd') }}</th>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>

                        </template>

                    </div>

                    <template v-else>
                        <az-empty-state msg="Nenhuma consolidação definida." icon="fas fa-table" />
                    </template>

                </div>

            </div>

            <pre v-if="false">{{ dados }}</pre>
        </template>

        <edicao-pesquisa-alerta ref="editfiltro" :pesquisa="true" @refresh="refresh_filtro" />

    </div>
</template>

<script>
import _ from 'lodash';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';
import PrintExport from '../../shared/PrintExport.vue';
import EdicaoPesquisaAlerta from './EdicaoPesquisaAlerta.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() { 
        return { 
            filtros: { 
                periodo: 'ma',
                id_pesquisa_alerta: "",
                search: "", 
                filtro: "", 
                id_cuidado_programa: "", 
                ultimo_atend: false, 
            },
            dados: null, 
            info: {
                analitico: true, 
            },
            consolidar_paciente: false, 
            acrescentar_resultado: false, 
        }
    },

    components: { 
        AzPeriodo,
        AzInput,
        AzEmptyState,
        CabecalhoGenerico, 
        PrintExport, 
        EdicaoPesquisaAlerta, 
        AzSubmit, 
    },

    computed: { 
        total_selecionados: function () { 
            return this.lista.filter(item => item.selecionado).length;
        },

        consolidacoes: function () { 
            const acoes = ( this.dados.acoes && this.dados.acoes.tabelas ) 
                ? this.chaves(this.dados.acoes.tabelas)
                : 0;

            const graficos = this.dados.graficos ? this.dados.graficos.length : 0;

            return acoes + graficos;
        },
        
        lista: function () { 
            if ( !this.dados )
                return [];

            let reg = this.$util.getregex(this.filtros.search);

            return this.dados.lista.filter(item => !this.filtros.search || reg.test(JSON.stringify(item)));
        },

        dados_exportacao: function () { 
            if ( this.consolidar_paciente ) { 

                let lista = _.groupBy(this.lista, 'paciente.id_pessoa');

                lista = _.map(lista, (items, chave) => { 
                    let primeiro = _.first(items);
                    
                    let retorno = { 
                        id_paciente: chave, 
                        paciente: _.get(primeiro, 'nome_paciente'), 
                        sexo: _.get(primeiro, 'paciente.cadastro.ch_sexo'),
                        idade: _.get(primeiro, 'paciente.cadastro.idade_anos'), 
                        dt_nascimento: _.get(primeiro, 'paciente.cadastro.dt_nascimento'),
                    };

                    _.each(items, (item, idx) => { 
                        retorno[(idx + 1) + '_id_atendimento'] = item.id_atendimento;
                        retorno[(idx + 1) + '_data'] = item.dt_inicio;
                        retorno[(idx + 1) + '_procedimento'] = item.procedimento.search;
                        retorno[(idx + 1) + '_operadora'] = item.plano.operadora.search;
                        retorno[(idx + 1) + '_plano'] = item.plano.search;
                        retorno[(idx + 1) + '_medico'] = item.medico.search;
                        retorno[(idx + 1) + '_unidade'] = item.unidade_operacao.st_nome;

                        if ( this.dados.pa.campos ) { 
                            this.dados.pa.campos.forEach(campo => { 
                                retorno[(idx + 1) + '_' + campo] = this.obter_valor(item, campo);
                            });
                        }
                    });

                    return retorno;

                });

                return lista;

            } else { 

                return this.lista.map(item => { 
                    let dados = {
                        id_atendimento: item.id_atendimento, 
                        data: item.dt_inicio, 
                        id_paciente: item.paciente.id_pessoa, 
                        paciente: item.nome_paciente, 
                        operadora: item.plano.operadora.search, 
                        plano: item.plano.search, 
                        sexo: item.paciente.cadastro.ch_sexo,
                        idade: item.paciente.cadastro.idade_anos, 
                        dt_nascimento: item.paciente.cadastro.dt_nascimento.substr(0,10),
                        procedimento: item.procedimento.search, 
                        medico: item.medico.search, 
                        unidade: item.unidade_operacao.st_nome, 
                        recepcao: item.recepcao ? item.recepcao.st_nome : '', 
                        avulso: item.avulso ? 'S' : 'N', 
                    };

                    if ( this.dados.pa.campos ) { 
                        this.dados.pa.campos.forEach(campo => { 
                            dados[campo] = this.obter_valor(item, campo);
                        });
                    }

                    return dados;
                });

            }
        },
    },

    props: ['id_pesquisa_alerta'],

    methods: {
        incluir_no_programa () { 
            if ( !confirm('Confirma incluir os pacientes selecionados no programa de cuidado coordenado?') )
                return;

            this.$util.atualizar(this, { 
                service: 'pesquisa_clinica',
                func: 'incluir_no_programa', 
                dados: { 
                    id_cuidado_programa: this.filtros.id_cuidado_programa, 
                    lista: this.lista.filter(item => item.selecionado), 
                }, 
                toast: true, 
            });

        },

        marcar_todos () { 
            let selecionado = this.lista.find(item => !item.selecionado) ? true : false;
            
            this.lista.forEach(item => { 
                item.selecionado = selecionado;
            });
        },

        agrupar (lista, campo) { 
            return _.groupBy(lista, campo);
        },

        chaves (lista) { 
            return lista ? _.keys(lista).length : 0;
        },

        titulo_campo (campo) { 
            const base = this.dados.pa.js_campos.find(item => item.id == campo);

            if ( base ) { 
                return base.titulo ? base.titulo : base.id;
            }

            return campo;
        },

        percentual (valor, lista, campo = null) { 
            const total = this.totalizar (lista, campo);

            if ( total ) { 
                return Math.round(( valor / total )* 100);
            }

            return;
        },

        totalizar (lista, campo = null) { 
            return campo ? _.sumBy(lista, campo) : _.sum(_.values(lista));
        },

        refresh_filtro (filtro) { 
            this.filtros.filtro = filtro;
        },

        incluir_filtro () { 
            this.$refs.editfiltro.incluir();
        },

        editar_filtro () { 
            if ( !this.filtros.filtro ) { 
                return;
            }

            this.$refs.editfiltro.editar(this.filtros.filtro);
        },

        obter_valor(item, campo) { 
            // const reg = item.atendimento.atendimento_procedimentos.find(atp => atp.anamnese && atp.anamnese[campo]);
        
            let valor = _.get(item, 'campos.' + campo, '');

            if ( valor === null || valor === undefined ) { 
               return '-';
            }

            // console.log(campo, valor, valor === null);

            return valor == 'true' ? 'Sim' : ( valor == 'false' ? 'Não' : valor );
        },
        load() { 
            this.$util.load(this, { 
                service: 'pesquisa_clinica',
                func: 'index',
                redir_api: true,
                parms: this.filtros, 
                loadTo: res => { 
                    if ( this.acrescentar_resultado && this.lista.length ) { 
                        this.dados.lista = _.concat(this.dados.lista, res.lista);
                        this.dados.graficos = [];
                    } else { 
                        this.dados = res;
                    }
                }
            });
        }
    },

    beforeMount () { 
        // this.filtros.filtro = this.id_pesquisa_alerta ? this.id_pesquisa_alerta : '';
    },

    mounted () { 
        this.filtros.filtro = this.id_pesquisa_alerta ? this.id_pesquisa_alerta : '';

        this.breadcrumb = [
                { name: "Pesquisa Clínica", path: "/pesquisa-clinica"},
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);
    },
    
}
</script>

<style scoped>
.panel-fullscreen {
  display: block;
  z-index: 999999;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  overflow: auto;
}
</style>